import * as React from 'react'
import { useTheme } from 'embed/hooks'
import { connect } from 'react-redux'
import { uiSelectedProductSelector } from 'embed/selectors/ui'
import { Product, PRODUCT_NAMES } from '@evenfinancial/even-ts-static'
import { MultiProductState } from 'ui/multi-product/reducers'

interface StoreProps {
  product: Product
}

export const DeactivatedEmbedView: React.FC<StoreProps> = ({ product }) => {
  const { backdropStyles, colorBackgroundSecondary, borderRadiusLarge } = useTheme()
  const productName = PRODUCT_NAMES[product] ?? 'financial products'
  return (
    <div
      style={{
        ...backdropStyles,
        backgroundColor: colorBackgroundSecondary,
        borderRadius: borderRadiusLarge,
        padding: '48px',
        textAlign: 'center',
      }}
    >
      This page is inactive, please visit{' '}
      <a href="https://fiona.com/" target="_blank" rel="noopener">
        Fiona.com
      </a>{' '}
      to search for {productName.toLowerCase()}.
    </div>
  )
}

const mapStateToProps = (state: MultiProductState) => ({
  product: uiSelectedProductSelector(state),
})

export const DeactivatedEmbed = connect(mapStateToProps)(DeactivatedEmbedView)
